import React from 'react';
import { Spin } from 'antd';
import { useFetchSingleShipment } from '@/hooks';
import { usePickupPrefill } from '@/hooks/useFedExPickup';
import type { ToggleDrawerFn } from '../ControlTower/types';
import PickupDetailsPanel from './PickupDetailsPanel';

interface PickupDetailsDrawerProps {
  shipmentId: string;
  legType?: 'CL' | 'EL';
  toggleDrawer: ToggleDrawerFn;
}

const PickupDetailsDrawer: React.FC<PickupDetailsDrawerProps> = ({
  shipmentId,
  legType,
  toggleDrawer,
}) => {
  const { prefill, isPrefillLoading } = usePickupPrefill(shipmentId);
  const { shipmentData } = useFetchSingleShipment(shipmentId, false, 'minimal');

  const backToDetail = () =>
    toggleDrawer('open', 'Detail', shipmentId, undefined, legType);
  const pickup =
    prefill?.activePickup?.status === 'SCHEDULED' ? prefill.activePickup : null;

  // Cancelled elsewhere (or never scheduled): nothing to show, so return to the shipment.
  const missing = !isPrefillLoading && !pickup;
  React.useEffect(() => {
    if (missing) toggleDrawer('open', 'Detail', shipmentId, undefined, legType);
  }, [missing, toggleDrawer, shipmentId, legType]);

  if (!pickup) return <Spin className='h-full w-full' />;

  return (
    <PickupDetailsPanel
      pickup={pickup}
      shipmentLabel={shipmentData?.reference_number}
      onBack={backToDetail}
      onClose={() => toggleDrawer('close', 'all', null)}
    />
  );
};

export default PickupDetailsDrawer;
